import { UseQueryResult } from "@tanstack/react-query";
import { useAuthQuery, UseQueryExtendedOptions, useToken } from "@rentablo/api";
import { useFeatureFlag } from "@hooks";
import { loadMyself } from "@api/v1/methods";
import { UserWithType } from "@api/v1/model";

export const useMyself = (
  options?: UseQueryExtendedOptions<UserWithType, AxiosApiError, UserWithType>
): UseQueryResult<UserWithType> => {
  const { data: token, isFetched } = useToken();
  const isEnabled = options?.enabled === undefined ? true : !!options?.enabled;
  const isPremiumEnabled = useFeatureFlag("PREMIUM");
  const requestData = useAuthQuery(
    ["myself"],
    ({ token }) => loadMyself(token),
    {
      ...options,
      enabled: !!token && isEnabled,
      refetchOnWindowFocus: true,
      staleTime: 0,
    }
  );

  // making sure isUserFree equals true at first even when we actually don't request the data
  if (isPremiumEnabled) {
    return {
      ...requestData,
      isFetched: isFetched ? (token ? requestData.isFetched : true) : false,
      data: {
        isUserPro: false,
        isUserPlus: false,
        isUserFree: true,
        ...requestData.data,
      },
    } as UseQueryResult<UserWithType>;
  }

  return {
    ...requestData,
    data: {
      ...requestData.data,
      isUserPro: true,
      isUserPlus: false,
      isUserFree: false,
    },
  } as UseQueryResult<UserWithType>;
};
